import React from 'react';
import { MapPin } from 'lucide-react';
const SERVICE_AREAS = ['Farmington Hills', 'Novi', 'Commerce', 'Walled Lake', 'Wixom', 'Livonia', 'Northville', 'Waterford', 'Farmington', 'West Bloomfield', 'Milford', 'White Lake'];
export function DoSomeMartialArtsServiceAreas() {
  return <section className="py-24 bg-paper border-y border-subtle-gray" data-id="element-988">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-989">
        <div className="inline-flex items-center gap-2 bg-storm-red text-white px-4 py-1.5 rounded-full text-sm font-bold uppercase tracking-wide mb-6" data-id="element-990">
          <MapPin className="w-4 h-4" data-id="element-991" />
          Where to Find Us
        </div>
        <h2 className="text-4xl md:text-5xl text-ink mb-6" data-id="element-992">
          Serving Southeast Michigan
        </h2>
        <p className="text-lg text-gray-warm mb-3 max-w-2xl mx-auto" data-id="element-993">
          Storm Taekwondo is located at{' '}
          <span className="font-bold text-ink" data-id="element-994">
            24786 Crestview, Farmington Hills, MI 48335
          </span>
          .
        </p>
        <p className="text-lg text-gray-warm mb-10 max-w-2xl mx-auto" data-id="element-995">
          Families and adults travel in from across the area:
        </p>

        <div className="flex flex-wrap justify-center gap-3 mb-10" data-id="element-996">
          {SERVICE_AREAS.map(area => <span key={area} className="bg-off-white border border-subtle-gray text-ink px-4 py-2 rounded-full font-medium text-sm" data-id="element-997">
              {area}
            </span>)}
        </div>

        <p className="text-gray-warm text-sm" data-id="element-998">
          <a href="tel:517-220-0621" className="font-bold text-storm-red hover:underline" data-id="element-999">
            Call 517-220-0621
          </a>{' '}
          with any questions before your visit.
        </p>
      </div>
    </section>;
}